import {Component, Input, OnInit} from '@angular/core';
import {EventTrackingService} from "../core/_services/event-tracking.service";
import {USER_EVENT_TYPE} from "../core/constants";
import {UserService} from "../core/_services/user.service";
import {UtilitiesService} from "../core/_services/utilities.service";
import {ConstantsService} from "../core/_services/constants.service";

@Component({
  selector: 'app-zipcheck',
  templateUrl: './zipcheck.component.html'
})
export class ZipcheckComponent implements OnInit {

    @Input() zipcheckData: any = {};
    @Input() partialZip: any = {};
    @Input() inServiceArea: boolean;
    @Input() showResult: boolean;

    success = false;
    error = false;
    errorMessage = '';
    errorHeader = '';
    errorResponseCode: any = null;
    busy = false;

    component = 'zipcheck';

    constructor(private userService: UserService,
                public constantsService: ConstantsService,
                public eventTrackingService: EventTrackingService) { }

    ngOnInit() { }

    resetMessages() {
        this.busy = false;
        this.error = false;
        this.errorHeader = "";
        this.errorMessage = "";
        this.errorResponseCode = null;
    } // resetMessages()

    onZipcheckFormSubmit() {
        this.resetMessages();
        this.partialZip = false;
        this.inServiceArea = false;

        this.busy = true;
        this.showResult = false;
        let params = {zip: this.zipcheckData.zip};
        this.userService.validateLocation(params, this.constructor.name)
            .subscribe(
                (result: any) => {
                    if (UtilitiesService.isNotEmpty(result)) {
                        if (result.responseCode == 100) {
                            this.inServiceArea = true;
                        } else if (result.responseCode == 101) {
                            this.partialZip = true;
                        }
                    } else {
                        this.error = true;
                        this.errorHeader = "Oops!";
                        this.errorMessage = `We were unable to validate your zip code. Please try again.`;
                    }
                    this.showResult = true;
                    this.busy = false;
                },
                error => {
                    if (error.responseCode == 308 && error.message) {
                        this.showResult = true;
                        this.inServiceArea = false;
                        this.eventTrackingService.trackEvent({
                            category: 'success',
                            type: USER_EVENT_TYPE.OOA_USER_ENTERED_WITH_ZIP_ZIPCHECK.value,
                            name: `${USER_EVENT_TYPE.OOA_USER_ENTERED_WITH_ZIP_ZIPCHECK.label} ${this.zipcheckData.zip}`,
                            component: this.component,
                        });
                    } else {
                        this.error = true;
                        this.errorHeader = "Oops!";
                        this.errorMessage = `We were unable to validate your zip code. Please try again.`;
                        this.eventTrackingService.trackErrorEvent(this.component, 'error', USER_EVENT_TYPE.VALIDATE_LOCATION_ZIPCHECK, '/user/validatelocation', params, error.responseCode);
                    }
                    this.busy = false;
                });
    } // onZipcheckFormSubmit()

    updateZip() {
        this.showResult = false;
    } // updateZip()

}
